import React from 'react'
import Pattern from 'assets/svg/retail-landing-page/pattern.svg'
import Cheap from 'assets/svg/retail-landing-page/cheap.svg'
import Cod from 'assets/svg/retail-landing-page/cod.svg'
import FreeShipping from 'assets/svg/retail-landing-page/free-shipping.svg'
import Loyalty from 'assets/svg/retail-landing-page/loyalty.svg'
import Quick from 'assets/svg/retail-landing-page/quick.svg'
import Vast from 'assets/svg/retail-landing-page/vast.svg'

const list = [
  {
    icon: Cheap,
    title: 'Murah',
    desc: 'Belanja barang jualan di Manuva Retail harga terbaik langsung dari manufakturnya.'
  },
  {
    icon: Vast,
    title: 'Lengkap',
    desc: 'Pilihan barang lengkap lebih dari 300 SKU.'
  },
  {
    icon: Quick,
    title: 'Cepat',
    desc: 'Barang akan dikirim dalam 1X24 jam.'
  },
  {
    icon: Cod,
    title: 'Pembayaran COD',
    desc: 'Terima barang dahulu baru melakukan pembayaran.'
  },
  {
    icon: FreeShipping,
    title: 'Gratis Pengiriman',
    desc: 'Untuk semua pembelian, dapatkan gratis ongkir pengiriman.'
  },
  {
    icon: Loyalty,
    title: 'Loyalty Points',
    desc: 'Belanja makin besar dan makin sering untuk mendapatkan harga semakin murah.'
  }
]

const Why = () => {
  return (
    <section id="industry" className="">
      <div className="pt-10 pb-10 md:py-[96px] lg:py-20 xl:py-[88px] px-6 lg:px-[56px] xl:px-[120px] max-w-[1440px] m-auto left-0 right-0">
        <div className="relative m-auto left-0 right-0 w-fit flex md:block">
          <img
            className="w-11 h-11 lg:w-16 lg:h-16 bottom-[0px] left-[-70px] xl:w-[72px] xl:h-[72px] lg:bottom-[0px] lg:left-[-120px] mr-4 md:absolute"
            src={Pattern}
          />
          <h1 className="leading-[140%] font-bold text-[28px] md:text-[40px] text-[#101838]">
            Kenapa belanja di Manuva Retail
          </h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-[40px] lg:mt-[64px] xl:mt-[68px]">
          {list.map(({ icon, title, desc }, idx) => (
            <div
              key={idx}
              className="p-6 xl:p-8 md:flex items-start"
              style={{
                boxShadow: '0px 4px 32px rgba(0, 0, 0, 0.05)'
              }}
            >
              <img src={icon} className="mr-4 mb-[24px] md:mb-0" />
              <div className="">
                <h1 className="mt-1 mb-[12px] text-[#101838] md:text-[24px] lg:text-[28px] text-[28px] font-bold leading-[150%]">
                  {title}
                </h1>
                <p className="text-[#969FB6] leading-[150%] font-normal text-base">
                  {desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Why
